import { render, staticRenderFns } from "./EducationManage.vue?vue&type=template&id=3c21c85a&scoped=true&"
import script from "./EducationManage.vue?vue&type=script&lang=js&"
export * from "./EducationManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21c85a",
  null
  
)

export default component.exports